
const SET_CAPTCHA_IMAGE = function (state, payload) {
  state.captchaImage = payload.data;
};

export const mutations = {
  SET_CAPTCHA_IMAGE
};
